module.exports = __webpack_public_path__ + "img/dne-exchange-mb.afd3e57e.jpg";